import { render, staticRenderFns } from "./TurnoverChart.vue?vue&type=template&id=5a7dfc56&scoped=true&"
import script from "./TurnoverChart.vue?vue&type=script&lang=js&"
export * from "./TurnoverChart.vue?vue&type=script&lang=js&"
import style0 from "./TurnoverChart.vue?vue&type=style&index=0&id=5a7dfc56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7dfc56",
  null
  
)

export default component.exports